import React from 'react';
import './Pages.css';

function Settings() {
  return (
    <div className="settings-page">
      <div className="page-header">
        <div>
          <h1>Settings</h1>
          <p className="page-subtitle">Configure your MailWatch preferences</p>
        </div>
      </div>

      <div className="settings-card">
        <h3>Coming Soon</h3>
        <p>Settings functionality will be added in a future update.</p>
        <div className="planned-features">
          <h4>Planned Settings:</h4>
          <ul>
            <li>Notification preferences</li>
            <li>Tracking defaults</li>
            <li>Data retention settings</li>
            <li>Account management</li>
            <li>Export options</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Settings;
